import PropTypes from 'prop-types';

import { evRecommendationClick } from 'events/recommendations';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import { track } from 'apis/amethyst';

import styles from 'styles/components/search/inlineVerticalRecos.scss';

const SearchInlineVerticalRecos = ({ inlineRecos, onInlineVerticalRecoClick, onHeartClick, showHearting, hearts, msaImageParams, showRatingStars, heartsList }, { testId }) => {
  const additionalMelodyCardProductClasses = { container: styles.searchVerticalReco };
  return (
    <aside className={styles.searchVerticalRecosContainer}>
      <h2 className={styles.heading}>New Arrivals</h2>
      <div className={styles.productsContainer}>
        {inlineRecos.map((v, i) =>
          <MelodyCardProduct
            key={`${v.productId}-${v.styleId}`}
            additionalClasses={additionalMelodyCardProductClasses}
            componentStyle="searchProductInlineVerticalRecos"
            onComponentClick={() => {
              onInlineVerticalRecoClick(i + 1, v.productId);
              track(evRecommendationClick, {
                index: i + 1,
                recommendationType: 'PRODUCT_RECOMMENDATION',
                recommendationValue: v.productId,
                recommendationSource: 'ZAPPOS_DATA_SCIENCE',
                widgetType: 'SIMILAR_PRODUCT_WIDGET'
              });
            }}
            showFavoriteHeart={showHearting}
            onHeartClick={onHeartClick}
            cardData={v}
            hearts={hearts}
            msaImageParams={msaImageParams}
            melodyCardTestId={testId('searchResultInlineVerticalReco')}
            showRatingStars={showRatingStars}
            heartsList={heartsList}
          />
        )}
      </div>
    </aside>
  );
};

SearchInlineVerticalRecos.contextTypes = {
  testId: PropTypes.func
};

export default SearchInlineVerticalRecos;
